import { SiteTypes } from '../enums';
import { getEndpointURL } from './getEndpointUrl';

export const goToFavouritesList = (listId: string) => {
  window.location.href = getEndpointURL(SiteTypes.FAVOURITES, `list/${listId}`);
};
